import { useRef } from 'react';
import { useHistory, useLocation, Route, Switch } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import logo from '../../images/logo.png';
import onboarding from '../../images/onboarding.jpg';
import eu_mic_logo from '../../images/eu-mic_logo.png';

export default function Onboarding() {
  const location = useLocation();
  const history = useHistory();

  const from = useRef(
    (location.state as { from: { pathname: string } })?.from ?? {
      pathname: '/',
    }
  );

  const callback = () => history.replace(from.current);

  return (
    <div className="Onboarding-container">
      <img src={onboarding} alt="Scolari in classe" className="Onboarding-image" />
      <div className="Onboarding-back">
        <div className="Content">
          <h2 className="Dark">Rendi ogni lezione un'esperienza coinvolgente!</h2>
          <div className="Onboarding-form">
            <img src={logo} alt="Progetti Sonori" className="Logo" />
            <Switch>
              <Route path="/login">
                <Login callback={callback} />
              </Route>
              <Route path="/register">
                <Register callback={callback} />
              </Route>
            </Switch>
          </div>
          <strong>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ width: '33.33%' }}>
                    <a
                      href="https://www.progettisonori.it/pwa-progetti-sonori"
                      target="_blank"
                      rel="noreferrer"
                      className="Dark"
                    >
                      App tutorial
                    </a>
                  </td>
                  <td style={{ width: '33.33%' }}>
                    <a href="https://www.progettisonori.it" target="_blank" rel="noreferrer" className="Dark">
                      Visita il sito
                    </a>
                  </td>
                  <td style={{ width: '33.33%' }}>
                    <a href="https://www.progettisonori.it/shop" target="_blank" rel="noreferrer" className="Dark">
                      Catalogo
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </strong>
        </div>
        <img
          src={eu_mic_logo}
          alt="Finanziato dall'Unione europea (NextGenerationEU) - Ministero della cultura"
          className="EU-MIC_Logo"
        />
      </div>
    </div>
  );
}
